import { render, staticRenderFns } from "./FeatureHomeTwo.vue?vue&type=template&id=03fe7bdd"
import script from "./FeatureHomeTwo.vue?vue&type=script&lang=js"
export * from "./FeatureHomeTwo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports